"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v = exports.o = exports.pic = exports.wps = exports.a = exports.wp = exports.w = void 0;
const component_1 = require("./component");
const wTags = [
    "abstractNum",
    "abstractNumId",
    "active",
    "activeRecord",
    "activeWritingStyle",
    "addressFieldName",
    "adjustLineHeightInTable",
    "adjustRightInd",
    "alias",
    "aliases",
    "alignBordersAndEdges",
    "allowPNG",
    "altChunk",
    "altChunkPr",
    "altName",
    "alwaysMergeEmptyNamespace",
    "alwaysShowPlaceholderText",
    "annotationRef",
    "applyBreakingRules",
    "attachedSchema",
    "attachedTemplate",
    "attr",
    "autoCaption",
    "autoCaptions",
    "autoFormatOverride",
    "autoHyphenation",
    "autoRedefine",
    "autoSpaceDE",
    "autoSpaceDN",
    "b",
    "bCs",
    "background",
    "balanceSingleByteDoubleByteWidth",
    "bar",
    "basedOn",
    "bdo",
    "bdr",
    "behavior",
    "behaviors",
    "between",
    "bibliography",
    "bidi",
    "bidiVisual",
    "blockQuote",
    "body",
    "bodyDiv",
    "bookFoldPrinting",
    "bookFoldPrintingSheets",
    "bookFoldRevPrinting",
    "bookmarkEnd",
    "bookmarkStart",
    "bordersDoNotSurroundFooter",
    "bordersDoNotSurroundHeader",
    "bottom",
    "br",
    "calcOnExit",
    "calendar",
    "cantSplit",
    "caps",
    "caption",
    "captions",
    "category",
    "cellDel",
    "cellIns",
    "cellMerge",
    "characterSpacingControl",
    "charset",
    "checkBox",
    "checkErrors",
    "checked",
    "citation",
    "clickAndTypeStyle",
    "clrSchemeMapping",
    "cnfStyle",
    "col",
    "colDelim",
    "color",
    "cols",
    "column",
    "comboBox",
    "comment",
    "commentRangeEnd",
    "commentRangeStart",
    "commentReference",
    "comments",
    "compat",
    "compatSetting",
    "connectString",
    "consecutiveHyphenLimit",
    "contentPart",
    "contextualSpacing",
    "continuationSeparator",
    "control",
    "cr",
    "cs",
    "customXml",
    "customXmlDelRangeEnd",
    "customXmlDelRangeStart",
    "customXmlInsRangeEnd",
    "customXmlInsRangeStart",
    "customXmlMoveFromRangeEnd",
    "customXmlMoveFromRangeStart",
    "customXmlMoveToRangeEnd",
    "customXmlMoveToRangeStart",
    "customXmlPr",
    "dataBinding",
    "dataSource",
    "dataType",
    "date",
    "dateFormat",
    "dayLong",
    "dayShort",
    "ddList",
    "decimalSymbol",
    "default",
    "defaultTabStop",
    "defaultTableStyle",
    "del",
    "delInstrText",
    "delText",
    "description",
    "destination",
    "dir",
    "dirty",
    "displayBackgroundShape",
    "displayHorizontalDrawingGridEvery",
    "displayVerticalDrawingGridEvery",
    "div",
    "divBdr",
    "divId",
    "divs",
    "divsChild",
    "doNotAutoCompressPictures",
    "doNotDemarcateInvalidXml",
    "doNotDisplayPageBoundaries",
    "doNotEmbedSmartTags",
    "doNotExpandShiftReturn",
    "doNotHyphenateCaps",
    "doNotIncludeSubdocsInStats",
    "doNotLeaveBackslashAlone",
    "doNotOrganizeInFolder",
    "doNotRelyOnCSS",
    "doNotSaveAsSingleFile",
    "doNotShadeFormData",
    "doNotSuppressBlankLines",
    "doNotTrackFormatting",
    "doNotTrackMoves",
    "doNotUseLongFileNames",
    "doNotUseMarginsForDrawingGridOrigin",
    "doNotValidateAgainstSchema",
    "docDefaults",
    "docGrid",
    "docPart",
    "docPartBody",
    "docPartCategory",
    "docPartGallery",
    "docPartList",
    "docPartObj",
    "docPartPr",
    "docPartUnique",
    "docParts",
    "docVar",
    "docVars",
    "document",
    "documentProtection",
    "documentType",
    "drawing",
    "drawingGridHorizontalOrigin",
    "drawingGridHorizontalSpacing",
    "drawingGridVerticalOrigin",
    "drawingGridVerticalSpacing",
    "dropDownList",
    "dstrike",
    "dynamicAddress",
    "eastAsianLayout",
    "effect",
    "em",
    "embedBold",
    "embedBoldItalic",
    "embedItalic",
    "embedRegular",
    "embedSystemFonts",
    "embedTrueTypeFonts",
    "emboss",
    "enabled",
    "encoding",
    "end",
    "endnote",
    "endnotePr",
    "endnoteRef",
    "endnoteReference",
    "endnotes",
    "entryMacro",
    "equation",
    "evenAndOddHeaders",
    "exitMacro",
    "fHdr",
    "family",
    "ffData",
    "fieldMapData",
    "fitText",
    "flatBorders",
    "fldChar",
    "fldSimple",
    "font",
    "fonts",
    "footerReference",
    "footnote",
    "footnotePr",
    "footnoteRef",
    "footnoteReference",
    "footnotes",
    "forceUpgrade",
    "formProt",
    "format",
    "formsDesign",
    "frame",
    "frameLayout",
    "framePr",
    "frameset",
    "framesetSplitbar",
    "ftr",
    "gallery",
    "glossaryDocument",
    "gridAfter",
    "gridBefore",
    "gridCol",
    "gridSpan",
    "group",
    "guid",
    "gutterAtTop",
    "hdr",
    "header",
    "headerReference",
    "headerSource",
    "headers",
    "helpText",
    "hidden",
    "hideGrammaticalErrors",
    "hideMark",
    "hideSpellingErrors",
    "highlight",
    "hps",
    "hpsBaseText",
    "hpsRaise",
    "hyperlink",
    "hyphenationZone",
    "i",
    "iCs",
    "id",
    "ignoreMixedContent",
    "ilvl",
    "imprint",
    "ind",
    "ins",
    "insideH",
    "insideV",
    "instrText",
    "isLgl",
    "jc",
    "keepLines",
    "keepNext",
    "kern",
    "kinsoku",
    "label",
    "lang",
    "lastRenderedPageBreak",
    "latentStyles",
    "left",
    "lid",
    "link",
    "linkStyles",
    "linkToQuery",
    "linkedToFile",
    "listEntry",
    "listItem",
    "listSeparator",
    "lnNumType",
    "lock",
    "locked",
    "longDesc",
    "lsdException",
    "lvl",
    "lvlJc",
    "lvlOverride",
    "lvlPicBulletId",
    "lvlRestart",
    "lvlText",
    "mailAsAttachment",
    "mailMerge",
    "mailSubject",
    "mainDocumentType",
    "mappedName",
    "marBottom",
    "marH",
    "marLeft",
    "marRight",
    "marTop",
    "marW",
    "matchSrc",
    "maxLength",
    "mirrorIndents",
    "mirrorMargins",
    "monthLong",
    "monthShort",
    "moveFrom",
    "moveFromRangeEnd",
    "moveFromRangeStart",
    "moveTo",
    "moveToRangeEnd",
    "moveToRangeStart",
    "movie",
    "multiLevelType",
    "name",
    "next",
    "noBorder",
    "noBreakHyphen",
    "noEndnote",
    "noLineBreaksAfter",
    "noLineBreaksBefore",
    "noProof",
    "noPunctuationKerning",
    "noResizeAllowed",
    "noWrap",
    "notTrueType",
    "nsid",
    "num",
    "numFmt",
    "numId",
    "numIdMacAtCleanup",
    "numPicBullet",
    "numPr",
    "numRestart",
    "numStart",
    "numStyleLink",
    "numbering",
    "oMath",
    "object",
    "objectEmbed",
    "objectLink",
    "odso",
    "optimizeForBrowser",
    "outline",
    "outlineLvl",
    "overflowPunct",
    "p",
    "pBdr",
    "pPr",
    "pPrChange",
    "pPrDefault",
    "pStyle",
    "pageBreakBefore",
    "panose1",
    "paperSrc",
    "permEnd",
    "permStart",
    "personal",
    "personalCompose",
    "personalReply",
    "pgBorders",
    "pgMar",
    "pgNum",
    "pgNumType",
    "pgSz",
    "picture",
    "pitch",
    "pixelsPerInch",
    "placeholder",
    "pos",
    "position",
    "printFormsData",
    "printFractionalCharacterWidth",
    "printPostScriptOverText",
    "printTwoOnOne",
    "printerSettings",
    "proofErr",
    "proofState",
    "ptab",
    "qFormat",
    "query",
    "r",
    "rFonts",
    "rPr",
    "rPrChange",
    "rPrDefault",
    "rStyle",
    "readModeInkLockDown",
    "recipientData",
    "recipients",
    "removeDateAndTime",
    "removePersonalInformation",
    "result",
    "revisionView",
    "richText",
    "right",
    "rsid",
    "rsidRoot",
    "rsids",
    "rt",
    "rtl",
    "rtlGutter",
    "ruby",
    "rubyAlign",
    "rubyBase",
    "rubyPr",
    "saveFormsData",
    "saveInvalidXml",
    "savePreviewPicture",
    "saveSmartTagsAsXml",
    "saveSubsetFonts",
    "saveThroughXslt",
    "saveXmlDataOnly",
    "scrollbar",
    "sdt",
    "sdtContent",
    "sdtEndPr",
    "sdtPr",
    "sectPr",
    "sectPrChange",
    "semiHidden",
    "separator",
    "settings",
    "shadow",
    "shd",
    "showEnvelope",
    "showXMLTags",
    "showingPlcHdr",
    "sig",
    "size",
    "sizeAuto",
    "smallCaps",
    "smartTag",
    "smartTagPr",
    "smartTagType",
    "snapToGrid",
    "softHyphen",
    "sourceFileName",
    "spaceForUL",
    "spacing",
    "specVanish",
    "src",
    "start",
    "startOverride",
    "statusText",
    "storeMappedDataAs",
    "strictFirstAndLastChars",
    "strike",
    "style",
    "styleLink",
    "styleLockQFSet",
    "styleLockTheme",
    "stylePaneFormatFilter",
    "stylePaneSortMethod",
    "styles",
    "subDoc",
    "suff",
    "summaryLength",
    "suppressAutoHyphens",
    "suppressLineNumbers",
    "suppressOverlap",
    "sym",
    "sz",
    "szCs",
    "t",
    "tab",
    "tabIndex",
    "table",
    "tabs",
    "tag",
    "targetScreenSz",
    "tbl",
    "tblBorders",
    "tblCaption",
    "tblCellMar",
    "tblCellSpacing",
    "tblDescription",
    "tblGrid",
    "tblGridChange",
    "tblHeader",
    "tblInd",
    "tblLayout",
    "tblLook",
    "tblOverlap",
    "tblPr",
    "tblPrChange",
    "tblPrEx",
    "tblPrExChange",
    "tblStyle",
    "tblStyleColBandSize",
    "tblStylePr",
    "tblStyleRowBandSize",
    "tblW",
    "tblpPr",
    "tc",
    "tcBorders",
    "tcFitText",
    "tcMar",
    "tcPr",
    "tcPrChange",
    "tcW",
    "temporary",
    "text",
    "textAlignment",
    "textDirection",
    "textInput",
    "textboxTightWrap",
    "themeFontLang",
    "title",
    "titlePg",
    "tl2br",
    "tmpl",
    "top",
    "topLinePunct",
    "tr",
    "tr2bl",
    "trHeight",
    "trPr",
    "trPrChange",
    "trackRevisions",
    "type",
    "types",
    "u",
    "udl",
    "uiPriority",
    "ulTrailSpace",
    "unhideWhenUsed",
    "uniqueTag",
    "updateFields",
    "useXSLTWhenSaving",
    "vAlign",
    "vMerge",
    "vanish",
    "vertAlign",
    "view",
    "viewMergedData",
    "w",
    "wAfter",
    "wBefore",
    "webHidden",
    "webSettings",
    "widowControl",
    "wordWrap",
    "writeProtection",
    "yearLong",
    "yearShort",
    "zoom",
    "txbxContent",
];
exports.w = {};
for (const key of wTags) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exports.w[key] = (0, component_1.makeComponentWithTag)(`w:${key}`);
}
const wpTags = [
    "align",
    "anchor",
    "bg",
    "bodyPr",
    "cNvCnPr",
    "cNvContentPartPr",
    "cNvFrPr",
    "cNvGraphicFramePr",
    "cNvGrpSpPr",
    "cNvPr",
    "cNvSpPr",
    "contentPart",
    "docPr",
    "effectExtent",
    "extLst",
    "extent",
    "graphicFrame",
    "grpSp",
    "grpSpPr",
    "inline",
    "lineTo",
    "linkedTxbx",
    "nvContentPartPr",
    "posOffset",
    "positionH",
    "positionV",
    "simplePos",
    "spPr",
    "start",
    "style",
    "txbx",
    "txbxContent",
    "wgp",
    "whole",
    "wpc",
    "wrapNone",
    "wrapPolygon",
    "wrapSquare",
    "wrapThrough",
    "wrapTight",
    "wrapTopAndBottom",
    "wsp",
    "xfrm",
];
exports.wp = {};
for (const key of wpTags) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exports.wp[key] = (0, component_1.makeComponentWithTag)(`wp:${key}`);
}
const aTags = [
    "accent1",
    "accent2",
    "accent3",
    "accent4",
    "accent5",
    "accent6",
    "ahLst",
    "ahPolar",
    "ahXY",
    "alpha",
    "alphaBiLevel",
    "alphaCeiling",
    "alphaFloor",
    "alphaInv",
    "alphaMod",
    "alphaModFix",
    "alphaOff",
    "alphaOutset",
    "alphaRepl",
    "anchor",
    "arcTo",
    "audioCd",
    "audioFile",
    "avLst",
    "backdrop",
    "band1H",
    "band1V",
    "band2H",
    "band2V",
    "bevel",
    "bevelB",
    "bevelT",
    "bgClr",
    "bgFillStyleLst",
    "biLevel",
    "bldChart",
    "bldDgm",
    "blend",
    "blip",
    "blipFill",
    "blue",
    "blueMod",
    "blueOff",
    "blur",
    "bodyPr",
    "bottom",
    "br",
    "buAutoNum",
    "buBlip",
    "buChar",
    "buClr",
    "buClrTx",
    "buFont",
    "buFontTx",
    "buNone",
    "buSzPct",
    "buSzPts",
    "buSzTx",
    "cNvCxnSpPr",
    "cNvGraphicFramePr",
    "cNvGrpSpPr",
    "cNvPicPr",
    "cNvPr",
    "cNvSpPr",
    "camera",
    "cell3D",
    "chExt",
    "chOff",
    "chart",
    "close",
    "clrChange",
    "clrFrom",
    "clrMap",
    "clrRepl",
    "clrScheme",
    "clrTo",
    "comp",
    "cont",
    "contourClr",
    "cpLocks",
    "cs",
    "cubicBezTo",
    "custClr",
    "custClrLst",
    "custDash",
    "custGeom",
    "cxn",
    "cxnLst",
    "cxnSp",
    "cxnSpLocks",
    "defPPr",
    "defRPr",
    "dgm",
    "dk1",
    "dk2",
    "ds",
    "duotone",
    "ea",
    "effect",
    "effectDag",
    "effectLst",
    "effectRef",
    "effectStyle",
    "effectStyleLst",
    "end",
    "endCxn",
    "endParaRPr",
    "ext",
    "extLst",
    "extraClrScheme",
    "extraClrSchemeLst",
    "extrusionClr",
    "fgClr",
    "fill",
    "fillOverlay",
    "fillRect",
    "fillRef",
    "fillStyleLst",
    "fillToRect",
    "firstCol",
    "firstRow",
    "flatTx",
    "fld",
    "fmtScheme",
    "folHlink",
    "font",
    "fontRef",
    "fontScheme",
    "gamma",
    "gd",
    "gdLst",
    "glow",
    "gradFill",
    "graphic",
    "graphicData",
    "graphicFrame",
    "graphicFrameLocks",
    "gray",
    "grayscl",
    "green",
    "greenMod",
    "greenOff",
    "gridCol",
    "grpFill",
    "grpSp",
    "grpSpLocks",
    "grpSpPr",
    "gs",
    "gsLst",
    "headEnd",
    "header",
    "headers",
    "highlight",
    "hlink",
    "hlinkClick",
    "hlinkHover",
    "hlinkMouseOver",
    "hsl",
    "hslClr",
    "hue",
    "hueMod",
    "hueOff",
    "innerShdw",
    "insideH",
    "insideV",
    "inv",
    "invGamma",
    "lastCol",
    "lastRow",
    "latin",
    "left",
    "lightRig",
    "lin",
    "ln",
    "lnB",
    "lnBlToTr",
    "lnDef",
    "lnL",
    "lnR",
    "lnRef",
    "lnSpc",
    "lnStyleLst",
    "lnT",
    "lnTlToBr",
    "lnTo",
    "lstStyle",
    "lt1",
    "lt2",
    "lum",
    "lumMod",
    "lumOff",
    "lvl1pPr",
    "lvl2pPr",
    "lvl3pPr",
    "lvl4pPr",
    "lvl5pPr",
    "lvl6pPr",
    "lvl7pPr",
    "lvl8pPr",
    "lvl9pPr",
    "majorFont",
    "masterClrMapping",
    "minorFont",
    "miter",
    "moveTo",
    "neCell",
    "noAutofit",
    "noFill",
    "norm",
    "normAutofit",
    "nvCxnSpPr",
    "nvGraphicFramePr",
    "nvGrpSpPr",
    "nvPicPr",
    "nvSpPr",
    "nwCell",
    "objectDefaults",
    "off",
    "outerShdw",
    "overrideClrMapping",
    "p",
    "pPr",
    "path",
    "pathLst",
    "pattFill",
    "pic",
    "picLocks",
    "pos",
    "prstClr",
    "prstDash",
    "prstGeom",
    "prstShdw",
    "prstTxWarp",
    "pt",
    "quadBezTo",
    "quickTimeFile",
    "r",
    "rPr",
    "rect",
    "red",
    "redMod",
    "redOff",
    "reflection",
    "relOff",
    "right",
    "rot",
    "round",
    "rtl",
    "sat",
    "satMod",
    "satOff",
    "scene3d",
    "schemeClr",
    "scrgbClr",
    "seCell",
    "shade",
    "snd",
    "softEdge",
    "solidFill",
    "sp",
    "sp3d",
    "spAutoFit",
    "spDef",
    "spLocks",
    "spPr",
    "spcAft",
    "spcBef",
    "spcPct",
    "spcPts",
    "srcRect",
    "srgbClr",
    "st",
    "stCxn",
    "stretch",
    "style",
    "swCell",
    "sx",
    "sy",
    "sym",
    "sysClr",
    "t",
    "tab",
    "tabLst",
    "tableStyle",
    "tableStyleId",
    "tailEnd",
    "tbl",
    "tblBg",
    "tblGrid",
    "tblPr",
    "tblStyle",
    "tblStyleLst",
    "tc",
    "tcBdr",
    "tcPr",
    "tcStyle",
    "tcTxStyle",
    "theme",
    "themeElements",
    "themeManager",
    "themeOverride",
    "tile",
    "tileRect",
    "tint",
    "tl2br",
    "top",
    "tr",
    "tr2bl",
    "txBody",
    "txDef",
    "txSp",
    "uFill",
    "uFillTx",
    "uLn",
    "uLnTx",
    "up",
    "useSpRect",
    "videoFile",
    "wavAudioFile",
    "wholeTbl",
    "xfrm",
];
exports.a = {};
for (const key of aTags) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exports.a[key] = (0, component_1.makeComponentWithTag)(`a:${key}`);
}
const wpsTags = [...wpTags, ...aTags];
exports.wps = {};
for (const key of wpsTags) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exports.wps[key] = (0, component_1.makeComponentWithTag)(`wps:${key}`);
}
const picTags = [
    "cNvPr",
    "cNvPicPr",
    "nvPicPr",
    "blipFill",
    "spPr",
    "pic",
];
exports.pic = {};
for (const key of picTags) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exports.pic[key] = (0, component_1.makeComponentWithTag)(`pic:${key}`);
}
const oTags = [
    "OLEObject",
    //
];
exports.o = {};
for (const key of oTags) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exports.o[key] = (0, component_1.makeComponentWithTag)(`o:${key}`);
}
const vTags = [
    "imagedata",
    "shape",
];
exports.v = {};
for (const key of vTags) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exports.v[key] = (0, component_1.makeComponentWithTag)(`v:${key}`);
}
//# sourceMappingURL=tags.js.map